export default "__VITE_ASSET__sVZrL5RX__"